import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import React, { useMemo } from 'react';
import { Box } from 'web-library';
import { ResitSubject } from '../../../../api/candidate/resit/model';
import { CoordinatorResitAction } from '../../logic/useCoordinatorResitData';
import SubjectSelectionTable from '../SubjectSelectionTable';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  icon: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  subjectContainer: {},
}));

interface CandidateSelectSubjectProps {
  dispatch: React.Dispatch<CoordinatorResitAction>;
  selectedCandidate: number;
  setSelectedCandidate: React.Dispatch<React.SetStateAction<number | null>>;
  candidateTableRows: {
    name: any;
    id: any;
  }[];
  state: any;
}

const CandidateSelectSubject = ({
  dispatch,
  selectedCandidate,
  setSelectedCandidate,
  candidateTableRows,
  state,
}: CandidateSelectSubjectProps) => {
  const { classes } = useStyles();

  const subjectTableRows = useMemo((): ResitSubject[] => {
    if (selectedCandidate === null) {
      return [];
    }

    const selectedCandidateSubjects =
      state.resitCandidates?.[candidateTableRows[selectedCandidate]?.id].subjects;
    if (!selectedCandidateSubjects) {
      return [];
    }

    return selectedCandidateSubjects.map(
      (item: any): ResitSubject => {
        const k = state.subjects?.[item];
        return { ...k };
      }
    );
  }, [candidateTableRows, selectedCandidate, state.resitCandidates, state.subjects]);

  return (
    <>
      <Box className={classes.subjectContainer}>
        <SubjectSelectionTable
          onClearSelection={() => {
            dispatch({
              type: 'UPDATE_SUBJECTS_SELECTION',
              payload: {
                selection: [],
                candidateId: candidateTableRows[selectedCandidate]?.id,
              },
            } as CoordinatorResitAction);
          }}
          hideDescription
          preSelectRows={
            state.resitCandidates?.[candidateTableRows[selectedCandidate]?.id].selectedSubjects
          }
          rows={subjectTableRows}
          onSelectionChange={(subjects: number[]) => {
            dispatch({
              type: 'UPDATE_SUBJECTS_SELECTION',
              payload: {
                selection: subjects,
                candidateId: candidateTableRows[selectedCandidate]?.id,
              },
            } as CoordinatorResitAction);
          }}
        />
      </Box>
    </>
  );
};

export default CandidateSelectSubject;
